import { highlightedFieldsInitialState } from '@/helpers/constants';
import { SET_HIGHLIGHTED_FIELDS } from '../types';

export default (state = highlightedFieldsInitialState, action) => {
  let newState = {};

  switch (action.type) {
    case SET_HIGHLIGHTED_FIELDS:
      newState = { highlightedFields: action.payload };
      break;
    default:
      break;
  }

  return {
    ...state,
    ...newState,
  };
};

export const getHighlightedFields = (state) => state.highlightFieldsReducer.highlightedFields;
